import BemIt from "@gtechdoodler/bem-it";
import { StyledMenuItem } from "./HamburgerMenuItem.styles";
import { MenuItemProps } from "./HamburgerMenuItem.types";

const HamburgerMenuItem: React.FC<MenuItemProps> = ({
	children,
	isVisible,
	...props
}) => {
	const menuItemClassName = new BemIt("HamburgerMenu")
		.el("item")
		.mod(isVisible ? "expand" : "").out;

	return (
		<StyledMenuItem className={menuItemClassName} {...props}>
			{children}
		</StyledMenuItem>
	);
};

export default HamburgerMenuItem;
